import React, { useEffect, useState } from 'react';
import StaticContainer from '../layouts/StaticContainer';
import { useLiveTranslation } from '../lib/LiveContext';
import { cmsPageProps } from '../lib/pageProps';
import Meta from '../layouts/Meta';
import JobCards from '../components/_shared/JobCards';
import ReasonCards from '../components/_shared/ReasonCards';
import { Job } from '../interfaces';
import { getJobPostList } from '../services/jobs';

const Volunteer = () => {

  const { t } = useLiveTranslation('volunteer')
  const [jobs, setJobs] = useState<Job[]>([]);

  const strings = {
    title: t('title'),
    category: 'Join Us',
    pageName: 'volunteer',
    jobsTitle: t('intro-h2'),
    jobsSubtitle: t('intro-p')
  }

  useEffect(() => {
    const call = async () => {
      const jobs_json = await getJobPostList();
      let jobs_array: Job[] = [];

      jobs_json?.forEach(job => { jobs_array.push(job.val()) });
      jobs_array = jobs_array?.filter(job => job.status === 'active' && job.pageName === strings.pageName);
      jobs_array = jobs_array.reverse();
      setJobs(jobs_array);
    }
    call();
  }, [])

  return (
    <StaticContainer title={t('title')} category="Join Us">

    <Meta title={t('title')} description={t('meta-description')}  keywords={t('meta-keyword')}/>

      <JobCards jobs={jobs} title={strings.jobsTitle} subtitle={strings.jobsSubtitle} />

      <ReasonCards t={t} />
      {/** <FundraisingVolunteerHubspot t={t} /> **/}
    </StaticContainer>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await cmsPageProps(locale, ['volunteer'])),
  },
  revalidate: 60,
})

export default Volunteer
